import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';

const TestEnvironmentPage: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">{t('abac.testEnvironmentPage')}</h1>
      <p>{t('abac.testEnvironmentDescription')}</p>
    </div>
  );
};

export default TestEnvironmentPage;



